import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Row, Form, Button, Image } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import { useAlert } from "../../context/AlertContext";
import { useLoading } from "../../context/LoadingContext";
import { PDFInputFile } from "../PDFFileHandler";
import { formatInputDate, hoursDifference } from "../../utils/Time";
import { MediaPreviewer, MediaUploader } from "../MediaUploader";
import {
  addEditServiceRequest,
  getServiceRequest
} from "../../commons/ServiceRequest";
import {
  FloatingControlComponent,
  SearchSelectComponent
} from "../FormComponent";
import {
  initializeSetOption,
  initializeSetOptionMulti
} from "../../utils/InitializeSetDefault";
import {
  concatenatedLabels,
  filteredIndex,
  filteredItemInArray,
  filteredMultiItemInArray,
  filteredNoneItemInArray,
  findItemBySearch,
  findItemInArray,
  hasValueObjects
} from "../../utils/ManageArray";
import {
  autoDisplayValue,
  formatDateTime,
  formatFileName,
  formatSplitKey,
  plusStringValue
} from "../../commons/FormatValue";
import {
  AddIcon,
  AttachFileIcon,
  DeleteIcon,
  GooglePinIcon,
  PreviewIcon
} from "../../data/iconImage";
import TableForm from "../TableForm";
import ButtonLink from "../ButtonLink";
import ConfirmModal from "../ConfirmModal";
import SearchFilter from "../SearchFilter";
import CardDisplayComponent from "../CardDisplayComponent";
import JobTypeService from "../../services/jobtype.service";
import DownTimesService from "../../services/downtime.service";
import CustomersService from "../../services/customer.service";
import EmployeesService from "../../services/employee.service";
import JobTypeSubService from "../../services/jobTypeSub.service";
import FileUploadsService from "../../services/fileupload.service";
import InformRepairJobsService from "../../services/informrepairjob.service";
import InformRepairItemsService from "../../services/informrepairitem.service";
import CustContractItemsService from "../../services/custcontractitem.service";

const RecordRepairForm = ({ onSubmitCallback }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { loading, setLoading } = useLoading(false);
  const [validated, setValidated] = useState(false);
  const [showModal, setShowModal] = useState({ confirm: false, media: false });
  const [Items, setItems] = useState([]);
  const [SeqPM, setSeqPM] = useState([]);
  const [DownTime, setDownTime] = useState([]);
  const [SearchValue, setSearchValue] = useState([]);
  const [CustContracts, setCustContracts] = useState([]);
  const [JobType, setJobType] = useState({ Main: [], Sub: [] });
  const [RepairJob, setRepairJob] = useState({ Inform: [], Items: [] });
  const [Customer, setCustomer] = useState({ Master: [], Branch: [] });
  const [Employee, setEmployee] = useState({
    Admin: [],
    Tech: [],
    Issue: [],
    Approve: []
  });
  const editForm = state?.name === "edit";
  const currentDate = formatInputDate(new Date().toISOString(), "Local");
  const searchInput = state?.SearchValue || [
    {
      name: "id",
      labelName: "repair_doc_no",
      label: "หมายเลขแจ้งซ่อม",
      filterBy: ["repair_doc_no"]
    }
  ];
  const defaultData = {
    Repair: {
      company_code: user.Com_Code,
      job_type_sub_id: null,
      job_type_id: null,
      cus_id: null,
      bp_cus_id: null,
      admin_brand_id: null,
      tech_sup_id: null,
      seq_pm_id: null,
      iss_job_id: null,
      approve_id: null,
      service_call: "",
      project_no: "",
      repair_date: currentDate?.date,
      repair_doc_no: "",
      ref_cus_ticket_no: "",
      ref_cus_ticket_date: "",
      inform_about_road: "",
      inform_email: "",
      inform_att_file: "",
      google_map_link: "",
      cus_direct_tex: "",
      cus_data_tex: "",
      condi_work_tex: "",
      condi_work_type: "",
      inform_doc_status: !editForm ? "OPEN" : null
    },
    Item: {
      company_code: user.Com_Code,
      inform_repair_id: null,
      item_id: null,
      dt_mas_id: null,
      inform_des: "",
      date_completed: ""
    }
  };
  const [data, setData] = useState({
    Repair: defaultData.Repair,
    Item: { array: [defaultData.Item] },
    Media: { PDF: null, Image: [], Video: [] },
    DeleteData: { Item: [], Media: [] }
  });
  const inputField = {
    Repair: [
      {
        name: "repair_doc_no",
        label: "หมายเลขแจ้งซ่อม",
        type: "text",
        disabled: true
      },
      {
        name: "ref_cus_ticket_no",
        label: "อ้างอิง Ticket (ลูกค้า)",
        type: "text",
        size: "1_5",
        required: true
      },
      {
        name: "ref_cus_ticket_date",
        label: "อ้างอิงวันที่แจ้ง (ลูกค้า)",
        type: "date",
        size: "1_5",
        format: (date) => date && formatInputDate(date, "Local")?.date,
        required: true
      },
      {
        name: "job_type_id",
        label: "ประเภทงาน",
        size: "1_5",
        required: true,
        noneAsync: true,
        filterBy: ["Job_Type_Name"],
        options: initializeSetOption({
          key: "Id",
          label: "Job_Type_Name",
          dataset: JobType.Main
        })
      },
      {
        name: "job_type_sub_id",
        label: "ประเภทงานย่อย",
        size: "1_5",
        required: true,
        noneAsync: true,
        filterBy: ["Job_Type_Sub_Name"],
        options: initializeSetOption({
          key: "Id",
          label: "Job_Type_Sub_Name",
          dataset: filteredItemInArray(
            JobType.Sub,
            "Job_Type_Id",
            data?.Repair?.job_type_id
          )
        })
      },
      {
        name: "inform_about_road",
        label: "ช่องทางรับเรื่อง",
        size: "1_5",
        required: true,
        noneAsync: true,
        options: [
          { value: "E-Mail", label: "E-Mail" },
          { value: "LINE", label: "LINE" },
          { value: "TELEPHONE", label: "TELEPHONE" }
        ]
      },
      {
        name: "repair_date",
        label: "วันที่รับแจ้งซ่อม",
        type: "date",
        size: "1_5",
        required: true,
        format: (value) => value && formatInputDate(value, "Local")?.date
      },
      {
        name: "cus_id",
        label: "รหัสลูกค้า",
        filterBy: ["Cus_Code"],
        options: initializeSetOption({
          key: "Id",
          label: "Cus_Code",
          dataset: Customer.Master
        }),
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: CustomersService.getAllCustomers(query),
            callback: ({ items }) =>
              setCustomer((prev) => ({ ...prev, Master: items }))
          }),
        required: true
      },
      {
        name: "Cus_Name",
        label: "ชื่อลูกค้า",
        type: "text",
        disabled: true,
        findValue: { data: Customer.Master, key: "Id", value: "cus_id" },
        size: "4_5"
      },
      {
        name: "project_no",
        label: "หมายเลขโครงการ",
        type: "text",
        readOnly: true,
        findValue: { data: CustContracts, key: "Contract_No" }
      },
      {
        name: "service_call",
        label: "Call No.",
        type: "text",
        readOnly: true,
        size: "1_5"
      },
      {
        name: "Cus_Address",
        label: "ที่อยู่",
        type: "text",
        size: 6,
        disabled: true,
        plusString: {
          plusValue: [
            "Cus_Road",
            "Cus_District",
            "Cus_SubDistrict",
            "Cus_Province",
            "Cus_ZipCode"
          ],
          operator: " ",
          data: findItemInArray(Customer.Master, "Id", data?.Repair?.cus_id)
        }
      },
      {
        name: "Cus_ContactTel",
        label: "เบอร์โทรผู้ติดต่อ 1",
        type: "text",
        disabled: true,
        findValue: { data: Customer.Master, key: "Id", value: "cus_id" }
      },
      {
        name: "Cus_ContactName",
        label: "ผู้ติดต่อ 1",
        type: "text",
        disabled: true,
        findValue: { data: Customer.Master, key: "Id", value: "cus_id" }
      },
      {
        name: "bp_cus_id",
        label: "รหัสสาขา",
        size: null,
        noneAsync: true,
        filterBy: ["Cus_Code"],
        options: initializeSetOption({
          key: "Id",
          label: "Cus_Code",
          dataset: Customer.Branch
        })
      },
      {
        name: "Cus_NumBranch",
        label: "เลขที่สาขา",
        type: "text",
        size: "1_25",
        disabled: true,
        findValue: { data: Customer.Branch, key: "Id", value: "bp_cus_id" }
      },
      {
        name: "Cus_Name",
        label: "ชื่อสาขา",
        type: "text",
        size: 2,
        disabled: true,
        findValue: { data: Customer.Branch, key: "Id", value: "bp_cus_id" }
      },
      {
        name: "Cus_ContactTel",
        label: "เบอร์โทรผู้ติดต่อ 2",
        type: "text",
        disabled: true,
        findValue: { data: Customer.Branch, key: "Id", value: "bp_cus_id" }
      },
      {
        name: "Cus_ContactName",
        label: "ผู้ติดต่อ 2",
        type: "text",
        disabled: true,
        findValue: { data: Customer.Branch, key: "Id", value: "bp_cus_id" }
      },
      {
        name: "Cus_Address",
        label: "ที่อยู่",
        size: 6,
        type: "text",
        disabled: true,
        plusString: {
          plusValue: [
            "Cus_Road",
            "Cus_District",
            "Cus_SubDistrict",
            "Cus_Province",
            "Cus_ZipCode"
          ],
          operator: " ",
          data: findItemInArray(Customer.Branch, "Id", data?.Repair?.bp_cus_id)
        }
      },
      { name: "inform_email", label: "อีเมลที่แจ้ง", type: "text" },
      {
        name: "admin_brand_id",
        label: "ธุรการผู้รับผิดชอบแบรนด์",
        required: true,
        minKeywordLength: 1,
        filterBy: ["Employee_Name", "Employee_Surname"],
        options: initializeSetOptionMulti({
          key: "Id",
          label: ["Employee_Name", "Employee_Surname"],
          operator: " ",
          dataset: filteredNoneItemInArray(
            Employee.Admin,
            "Id",
            data?.Repair?.tech_sup_id
          )
        }),
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: EmployeesService.getAllEmployees(query),
            callback: ({ items }) =>
              setEmployee((prev) => ({ ...prev, Admin: items }))
          })
      },
      {
        name: "google_map_link",
        label: "Google Map",
        type: "text",
        size: "8_33"
      },
      {
        name: "GoogleMapButton",
        classNames: { col: "w-auto" },
        type: "button",
        size: "0_67",
        icon: { src: GooglePinIcon, alt: "Google Pin Icon" },
        onClick: () =>
          window.open(
            data?.Repair?.google_map_link || "https://www.google.com/maps",
            "_blank"
          )
      },
      {
        name: "tech_sup_id",
        label: "ชื่อทีม/หัวหน้าช่าง",
        required: true,
        minKeywordLength: 1,
        filterBy: ["Employee_Name", "Employee_Surname"],
        options: initializeSetOptionMulti({
          key: "Id",
          label: ["Employee_Name", "Employee_Surname"],
          operator: " ",
          dataset: filteredNoneItemInArray(
            Employee.Tech,
            "Id",
            data?.Repair?.admin_brand_id
          )
        }),
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: EmployeesService.getAllEmployees(query),
            callback: ({ items }) =>
              setEmployee((prev) => ({ ...prev, Tech: items }))
          })
      },
      {
        name: "inform_att_file",
        label: "ไฟล์แนบ",
        type: "text",
        size: "7_25",
        readOnly: true,
        format: (value) => formatFileName(value)
      },
      {
        name: "PreviewButton",
        type: "button",
        size: "0_67",
        disabled: !data?.Repair?.inform_att_file,
        icon: { src: PreviewIcon, alt: "Preview Icon" },
        onClick: () =>
          navigate("preview", {
            state: {
              ...state,
              data,
              Customer,
              Items,
              Employee,
              SearchValue,
              filename: data?.Repair?.inform_att_file
            }
          })
      },
      {
        name: "DeleteButton",
        type: "button",
        size: "0_67",
        disabled: !data?.Repair?.inform_att_file,
        icon: { src: DeleteIcon, alt: "Delete Icon" },
        onClick: () =>
          handleDeletePDF(
            data?.Repair?.id,
            "ใบแจ้งซ่อม/PDF",
            data?.Repair?.inform_att_file
          )
      },
      {
        name: "AttachButton",
        type: "button",
        size: "0_67",
        disabled: !!data?.Repair?.inform_att_file,
        icon: { src: AttachFileIcon, alt: "Attach File Icon" }
      },
      {
        name: "inform_doc_status",
        label: "สถานะใบแจ้งงาน",
        type: editForm ? "select" : "text",
        readOnly: true,
        noneAsync: true,
        options: [
          { value: "OPEN", label: "OPEN" },
          { value: "CANCEL", label: "CANCEL" },
          { value: "CLOSED", label: "CLOSED" }
        ]
      }
    ],
    Item: [
      {
        name: "item_id",
        label: "รหัสอุปกรณ์",
        type: "select",
        noneRequired: true,
        minKeywordLength: 1,
        filterBy: ["Item.Item_Code"],
        options: initializeSetOption({
          key: "Item_Id",
          label: "Item.Item_Code",
          dataset: Items
        }),
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest:
              CustContractItemsService.getAllCustContractItems(query),
            callback: ({ items }) => setItems(items)
          })
      },
      {
        name: "Item.Item_Name_TH",
        label: "รายละเอียดอุปกรณ์",
        type: "text",
        findValue: { data: Items, key: "Id", value: "item_id" },
        readOnly: true
      },
      {
        name: "inform_des",
        label: "อาการที่ได้รับแจ้ง",
        type: "text",
        noneRequired: true
      },
      {
        name: "dt_mas_id",
        label: "จน.ชม.ช่างทำงาน (DT)",
        type: "select",
        noneAsync: true,
        noneRequired: true,
        filterBy: ["DT_Hrs"],
        options: initializeSetOption({
          key: "Id",
          label: "DT_Hrs",
          dataset: DownTime
        })
      },
      {
        name: "date_completed",
        label: "วัน/เวลา/ครบกำหนด",
        type: "text",
        readOnly: true,
        format: ({ dt_mas_id, date_completed }) => {
          if (dt_mas_id) {
            const { DT_Hrs } = findItemInArray(DownTime, "Id", dt_mas_id) || {};
            const d = new Date(date_completed || Date.now());
            const hourDiff = hoursDifference(d, DT_Hrs)?.toISOString();
            const dt = formatInputDate(hourDiff, "ISO").datetime;
            return DT_Hrs ? formatDateTime(dt, "DD/MM/YYYY HH:MM น.") : "";
          }
        }
      }
    ],
    moreRepair: [
      {
        name: "condi_work_type",
        label: "มี PM/ไม่มี PM",
        noneAsync: true,
        options: [
          { value: "PM", label: "มี PM" },
          { value: "Non_PM", label: "ไม่มี PM " }
        ]
      },
      {
        name: "seq_pm_id",
        label: "เลขที่ใบสั่งงาน",
        options: initializeSetOption({
          key: "Id",
          label: "Seq_Pm_No",
          dataset: SeqPM
        })
      },
      {
        name: "iss_job_id",
        label: "ผู้จ่ายงาน (FVC)",
        minKeywordLength: 1,
        required: true,
        filterBy: ["Employee_Name", "Employee_Surname"],
        options: initializeSetOptionMulti({
          key: "Id",
          label: ["Employee_Name", "Employee_Surname"],
          operator: " ",
          dataset: Employee.Issue
        }),
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: EmployeesService.getAllEmployees(query),
            callback: ({ items }) =>
              setEmployee((prev) => ({ ...prev, Issue: items }))
          })
      },
      {
        name: "approve_id",
        label: "ผู้อนุมัติ",
        minKeywordLength: 1,
        required: true,
        filterBy: ["Employee_Name", "Employee_Surname"],
        options: initializeSetOptionMulti({
          key: "Id",
          label: ["Employee_Name", "Employee_Surname"],
          operator: " ",
          dataset: Employee.Approve
        }),
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: EmployeesService.getAllEmployees(query),
            callback: ({ items }) =>
              setEmployee((prev) => ({ ...prev, Approve: items }))
          })
      }
    ]
  };

  const handleUploadPDF = (destination, file) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: FileUploadsService.createFileUploads(destination, [file]),
      callback: ({ files }) =>
        handleChange({ name: "inform_att_file", value: files?.[0] })
    });
  };

  const handleDeletePDF = (id, destination, file) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: FileUploadsService.deleteFileUploads(destination, file),
      callback: () => {
        handleChange({ name: "inform_att_file", value: "" });
        if (editForm) {
          addEditServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: InformRepairJobsService.updatedInformRepairJobs(
              id,
              { inform_att_file: "" }
            )
          });
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: InformRepairJobsService.getAllInformRepairJobs(),
            callback: (res) =>
              setRepairJob((prev) => ({ ...prev, Inform: res }))
          });
        }
      }
    });
  };

  const handleChange = ({ name, value }) => {
    setData((prev) => ({
      ...prev,
      Repair: {
        ...prev?.Repair,
        ...(name === "cus_id" && { bp_cus_id: null }),
        [name]: value
      }
    }));

    if (name === "cus_id") {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: CustomersService.getCustomerBranches(value),
        callback: (res) => setCustomer((prev) => ({ ...prev, Branch: res }))
      });
    }
  };

  const handleMediaUpload = ({ type, files }) => {
    setData((prev) => ({
      ...prev,
      Media: {
        ...prev.Media,
        [type]: filteredIndex([...prev.Media?.[type], ...files], "name")
      }
    }));
  };

  const handleDeleteMedia = ({ type, file }) => {
    const dataMedia = data.Media?.[type].filter(
      ({ name }) => name !== file.name
    );
    const delMedia = data.Repair?.repair_job_files?.find(
      ({ file_path }) => file_path?.split("/")?.[2] === file.name
    );
    setData((prev) => ({
      ...prev,
      Media: { ...prev.Media, [type]: dataMedia },
      DeleteData: {
        ...prev.DeleteData,
        Media: [...prev.DeleteData.Media, delMedia]
      }
    }));
  };

  const handleSearchFilter = (search) => {
    setSearchValue(search);

    const searchRepair = findItemBySearch(RepairJob.Inform, search);

    setCustomer({
      Master: [searchRepair?.concern_customer_items],
      Branch: [searchRepair?.sub_cus_items]
    });
    setEmployee({
      Admin: [searchRepair?.admin_brand_items],
      Tech: [searchRepair?.tech_sub_items],
      Issue: [searchRepair?.iss_job_items],
      Approve: [searchRepair?.approve_items]
    });

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: InformRepairItemsService.getAllInformRepairItems(),
      callback: (res) => {
        const filteredData =
          filteredItemInArray(res, "inform_repair_id", searchRepair?.id) || [];
        const itemsToAdd = filteredData.map(({ repair_items }) => repair_items);
        const filteredItem =
          filteredData.length > 0 ? filteredData : [defaultData.Item];

        setItems(itemsToAdd);
        setData((prev) => ({ ...prev, Item: { array: filteredItem } }));
      }
    });

    if (searchRepair?.repair_job_files?.length > 0) {
      searchRepair?.repair_job_files.map(({ file_path, file_type }) => {
        const filename = file_path.split("/")?.[2];
        const handleSetMedia = (prev, file, type) => {
          file.name = filename;
          return { ...prev.Media, [type]: [...prev.Media?.[type], file] };
        };
        getServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: FileUploadsService.getFileUploads(
            "ใบแจ้งซ่อม/Media",
            filename
          ),
          callback: (file) =>
            setData((prev) => ({
              ...prev,
              Media: handleSetMedia(prev, file, file_type)
            }))
        });
      });
    }

    setData((prev) => ({ ...prev, Repair: searchRepair }));
  };

  const checkValidity = () => {
    const checkKey = [
      "job_type_sub_id",
      "job_type_id",
      "cus_id",
      "admin_brand_id",
      "tech_sup_id",
      "iss_job_id",
      "approve_id"
    ];
    const { hasValue, emptyKey } = hasValueObjects([data.Repair], checkKey);
    if (hasValue?.length > 0) {
      const { Repair, moreRepair } = inputField;
      const sumEmptyKey =
        concatenatedLabels(emptyKey, Repair) +
        concatenatedLabels(emptyKey, moreRepair);
      showAlert({
        error: "ข้อผิดพลาด",
        message: `กรุณากรอกข้อมูลให้ครบถ้วน (${sumEmptyKey})`,
        type: "danger"
      });
      return false;
    }
    return true;
  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity() || !checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else setShowModal((prev) => ({ ...prev, confirm: true }));
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal((prev) => ({ ...prev, confirm: showCallback }));

    if (dataCallback) {
      const { Repair, ...data } = dataCallback.data;
      onSubmitCallback({
        ...data,
        Repair: {
          ...Repair,
          job_type_sub_id: Number(Repair?.job_type_sub_id) || null,
          job_type_id: Number(Repair?.job_type_id) || null,
          cus_id: Number(Repair?.cus_id) || null,
          bp_cus_id: Number(Repair?.bp_cus_id) || null,
          admin_brand_id: Number(Repair?.admin_brand_id) || null,
          tech_sup_id: Number(Repair?.tech_sup_id) || null,
          iss_job_id: Number(Repair?.iss_job_id) || null,
          approve_id: Number(Repair?.approve_id) || null
        }
      });
    }
  };

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: JobTypeService.getAllJobTypes(),
      callback: (res) =>
        setJobType((prev) => ({
          ...prev,
          Main: filteredMultiItemInArray(res, "Job_Type_Code", ["002"])
        }))
    });
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: JobTypeSubService.getAllJobTypeSubs(),
      callback: (res) => setJobType((prev) => ({ ...prev, Sub: res }))
    });
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: DownTimesService.getAllDownTimes(),
      callback: (res) => setDownTime(res)
    });
    if (state?.data) setData(state?.data);
    if (state?.Items) setItems(state?.Items);
    if (state?.Customer) setCustomer(state?.Customer);
    if (state?.Employee) setEmployee(state?.Employee);

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: InformRepairJobsService.getAllInformRepairJobs(),
      callback: (res) => setRepairJob((prev) => ({ ...prev, Inform: res }))
    });
  }, []);

  return (
    <>
      {editForm && (
        <CardDisplayComponent
          header={{
            title: { text: "ค้นหาหมายเลขแจ้งซ่อม", className: "text-center" }
          }}
          body={{
            element: (
              <SearchFilter
                data={RepairJob.Inform}
                inputField={searchInput}
                searchCallback={handleSearchFilter}
              />
            )
          }}
        />
      )}

      <Form noValidate validated={validated} onSubmit={handleValidated}>
        <CardDisplayComponent
          body={{
            as: Row,
            element: inputField.Repair.map(
              (
                {
                  name,
                  label,
                  type,
                  size,
                  icon,
                  options,
                  filterBy,
                  noneAsync,
                  queryService,
                  minKeywordLength,
                  format,
                  findValue,
                  plusString,
                  disabled,
                  readOnly,
                  required,
                  onClick
                },
                idx
              ) => {
                const value = formatSplitKey(name, ".", data?.Repair);
                const result =
                  (name === "Attach_File" && formatFileName(value)) ||
                  (format && format(value, idx)) ||
                  (plusString &&
                    plusStringValue(
                      plusString?.plusValue,
                      plusString?.operator,
                      plusString?.data
                    )) ||
                  (findValue &&
                    autoDisplayValue({
                      name,
                      type,
                      findValue: {
                        ...findValue,
                        value: formatSplitKey(
                          findValue?.value || findValue?.key,
                          ".",
                          data?.Repair
                        )
                      }
                    })) ||
                  value;

                return (
                  <Col
                    key={idx}
                    sm={size === null ? null : size || 3}
                    className={idx < inputField.Repair.length - 5 ? "mb-3" : ""}
                  >
                    {type ? (
                      type === "button" ? (
                        name === "AttachButton" ? (
                          <PDFInputFile
                            onFileChange={({ file, blob }) => {
                              setData((prev) => ({
                                ...prev,
                                Media: { ...prev.Media, PDF: { file, blob } }
                              }));
                              handleUploadPDF("ใบแจ้งซ่อม/PDF", file);
                            }}
                            button={{
                              icon,
                              disabled,
                              color: "outline-secondary",
                              className: "mt-2 p-2 rounded-circle",
                              style: { width: "45px" }
                            }}
                          />
                        ) : (
                          <Button
                            variant="outline-secondary"
                            className="my-2 px-2 rounded-circle"
                            disabled={disabled}
                            onClick={onClick}
                            style={{ width: "45px" }}
                          >
                            <Image src={icon?.src} alt={icon?.alt} />
                          </Button>
                        )
                      ) : (
                        <FloatingControlComponent
                          type={type}
                          name={name}
                          label={label}
                          disabled={disabled}
                          readOnly={readOnly}
                          required={required}
                          placeholder="โปรดระบุ"
                          className={{
                            label:
                              idx < inputField.Repair.length - 5 ? "mb-1" : ""
                          }}
                          onChange={({ target }) =>
                            handleChange({ name, value: target.value })
                          }
                          value={result}
                        />
                      )
                    ) : (
                      <SearchSelectComponent
                        floatingClass={
                          idx < inputField.Repair.length - 5 ? "mb-1" : ""
                        }
                        labelField={label}
                        placeholder="โปรดเลือก"
                        filterBy={filterBy}
                        noneAsync={noneAsync}
                        options={options || []}
                        queryService={queryService}
                        isInvalid={required && ["", null].includes(result)}
                        minKeywordLength={minKeywordLength}
                        onChange={(change) =>
                          handleChange({ name, value: change?.value })
                        }
                        value={`${result}`}
                      />
                    )}
                  </Col>
                );
              }
            )
          }}
        />

        <CardDisplayComponent
          header={{ title: { text: "รายละเอียดอุปกรณ์ที่แจ้งซ่อม" } }}
          body={{
            element: (
              <TableForm
                data={data.Item.array}
                columns={inputField.Item}
                defaultData={defaultData.Item}
                onChangeCallback={(newData, disValue) => {
                  setData((prev) => ({
                    ...prev,
                    Item: {
                      array: newData.map(
                        ({ item_id, dt_mas_id, date_completed, ...item }) => ({
                          ...item,
                          item_id: Number(item_id) || null,
                          dt_mas_id: Number(dt_mas_id) || null,
                          date_completed: dt_mas_id
                            ? date_completed || currentDate?.datetime
                            : "",
                          company_code: user.Com_Code
                        })
                      )
                    },
                    DeleteData: {
                      ...prev.DeleteData,
                      Item: [
                        ...prev.DeleteData.Item,
                        ...data.Item.array.filter((i) =>
                          newData.every((n) => i?.id && i?.id !== n?.id)
                        )
                      ]
                    }
                  }));
                }}
              />
            )
          }}
        />

        <CardDisplayComponent
          body={{
            element: (
              <FloatingControlComponent
                type="text"
                name="cus_direct_tex"
                label="คำสั่งเพิ่มเติม (ลูกค้า)"
                placeholder="โปรดระบุ"
                onChange={({ target }) =>
                  handleChange({ name: "cus_direct_tex", value: target?.value })
                }
                value={formatSplitKey("cus_direct_tex", ".", data?.Repair)}
              />
            )
          }}
        />

        <CardDisplayComponent
          body={{
            element: (
              <FloatingControlComponent
                type="text"
                name="cus_data_tex"
                label="ข้อมูลที่ได้รับแจ้ง (ลูกค้า)"
                placeholder="โปรดระบุ"
                onChange={({ target }) =>
                  handleChange({ name: "cus_data_tex", value: target?.value })
                }
                value={formatSplitKey("cus_data_tex", ".", data?.Repair)}
              />
            )
          }}
        />

        <CardDisplayComponent
          moreButton={{
            top: (
              <div className="p-3 pb-1 d-flex justify-content-end">
                <MediaUploader
                  accept="image/*"
                  buttonIcon={AddIcon}
                  buttonName="เพิ่มรูปภาพ"
                  onSubmitCallbackMedia={({ files }) =>
                    handleMediaUpload({ type: "Image", files })
                  }
                />
              </div>
            )
          }}
          header={{ title: { text: "รูปภาพประกอบ (ลูกค้า)" } }}
          body={{
            as: Row,
            element: (
              <MediaPreviewer
                deletedBtn
                mediaType="Image"
                loading={loading}
                filePreview={filteredIndex(data.Media?.Image, "name")}
                onDeleteCallback={(file) =>
                  handleDeleteMedia({ type: "Image", file })
                }
              />
            )
          }}
        />

        <CardDisplayComponent
          moreButton={{
            top: (
              <div className="p-3 pb-1 d-flex justify-content-end">
                <MediaUploader
                  accept="video/*"
                  buttonIcon={AddIcon}
                  buttonName="เพิ่มวีดีโอ"
                  onSubmitCallbackMedia={({ files }) =>
                    handleMediaUpload({ type: "Video", files })
                  }
                />
              </div>
            )
          }}
          header={{ title: { text: "วีดีโอประกอบ (ลูกค้า)" } }}
          body={{
            as: Row,
            element: (
              <MediaPreviewer
                deletedBtn
                mediaType="Video"
                loading={loading}
                filePreview={filteredIndex(data.Media?.Video, "name")}
                onDeleteCallback={(file) =>
                  handleDeleteMedia({ type: "Video", file })
                }
              />
            )
          }}
        />

        <CardDisplayComponent
          body={{
            as: Row,
            element: (
              <>
                <Col sm={12} className="mb-3">
                  <FloatingControlComponent
                    type="text"
                    name="condi_work_tex"
                    label="เงื่อนไขในการทำงาน"
                    placeholder="โปรดระบุ"
                    className={{ label: "mb-1" }}
                    onChange={({ target }) =>
                      handleChange({
                        name: "condi_work_tex",
                        value: target.value
                      })
                    }
                    value={formatSplitKey("condi_work_tex", ".", data?.Repair)}
                  />
                </Col>

                {inputField.moreRepair.map(
                  (
                    {
                      name,
                      label,
                      options,
                      required,
                      filterBy,
                      noneAsync,
                      queryService,
                      minKeywordLength
                    },
                    idx
                  ) => {
                    const result = formatSplitKey(name, ".", data?.Repair);
                    return (
                      <Col key={idx} sm={3}>
                        <SearchSelectComponent
                          placeholder="โปรดเลือก"
                          labelField={label}
                          filterBy={filterBy}
                          noneAsync={noneAsync}
                          options={options || []}
                          queryService={queryService}
                          minKeywordLength={minKeywordLength}
                          isInvalid={required && ["", null].includes(result)}
                          onChange={(change) =>
                            handleChange({ name, value: change?.value })
                          }
                          value={result}
                        />
                      </Col>
                    );
                  }
                )}
              </>
            )
          }}
        />

        <CardDisplayComponent
          footer={{
            className: "text-center",
            element: (
              <>
                {!editForm && (
                  <ButtonLink
                    linkTo="preview"
                    stateData={{ name: "check_PM" }}
                    buttonClass="me-4 px-5 py-2 text-dark rounded-pill"
                    buttonName="ตรวจสอบ PM"
                  />
                )}

                <Button
                  type="submit"
                  variant="success"
                  className="px-5 py-2 text-dark rounded-pill"
                >
                  {editForm ? "บันทึกการแก้ไข" : "บันทึกข้อมูล"}
                </Button>
                <ConfirmModal
                  show={showModal.confirm}
                  data={{ data }}
                  content={editForm ? "edit" : "save"}
                  onSubmitCallback={handleSubmit}
                />
              </>
            )
          }}
        />
      </Form>
    </>
  );
};

RecordRepairForm.propTypes = { onSubmitCallback: PropTypes.func };

export default RecordRepairForm;
